import { Fragment, memo } from 'react';

/** Capturing group so `String.split` keeps the emphasised runs as their own segments. */
const BOLD_SEGMENT_PATTERN = /(\*\*[^*]+\*\*)/g;

export type WorkspaceAgentPanelConsentSummaryProps = {
  summary: string;
};

/**
 * An `output` for its implicit `status` role: announced politely rather than focused, so a prompt
 * arriving mid-sentence reaches a screen reader without pulling the caret out of the composer.
 */
export const WorkspaceAgentPanelConsentSummary = memo(({ summary }: WorkspaceAgentPanelConsentSummaryProps) => (
  <output className="block text-14 text-gray-12 leading-5">
    {summary.split(BOLD_SEGMENT_PATTERN).map((segment, index) =>
      segment.startsWith('**') && segment.endsWith('**') ? (
        <strong className="font-semibold" key={`bold-${segment}`}>
          {segment.slice(2, -2)}
        </strong>
      ) : (
        <Fragment key={`text-${segment}-${index}`}>{segment}</Fragment>
      ),
    )}
  </output>
));

WorkspaceAgentPanelConsentSummary.displayName = 'WorkspaceAgentPanelConsentSummary';
